/* eslint-disable react/jsx-props-no-spreading */
import { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
// Components
import { cn } from '@repo/zolintra-utils';
import { Header } from '../../organisms/Header/Header';
import { Menu } from '../../organisms/Menu/Menu';
import { MenuEntry } from '../../atoms/MenuEntry/MenuEntry';
import { MOBILE_MEDIA_QUERY, useMediaQuery } from '../../../hooks/useMediaQuery';
// eslint-disable-next-line import/no-unresolved
import Logo from '../../../assets/logo.svg?react';
// Styles
import styles from './PageLayout.module.css';

const menuItems = [
  {
    label: 'main',
    entries: [
      {
        label: 'Tableau de bord',
        href: import.meta.env.VITE_INTRA_URL,
        icon: 'presentationChart',
        isActive: false,
      },
      {
        label: 'Staffing',
        href: `${import.meta.env.VITE_INTRA_URL}/agenda/v2`,
        icon: 'staffing',
        isActive: false,
      },
      {
        label: 'Planning',
        href: '/planning',
        icon: 'calendar',
        isActive: false,
      },
      {
        label: 'Télétravail',
        href: '/remote-workings',
        icon: 'home',
        isActive: false,
      },
      {
        label: 'Congés',
        href: '/leaves',
        icon: 'timerPause',
        isActive: false,
      },

    ],
  },

  // {
  //   label: 'business',
  //   entries: [
  //     {
  //       label: 'Missions',
  //       href: '/',
  //       icon: 'calendar',
  //       isActive: false,
  //     },
  //     {
  //       label: 'Clients',
  //       href: '#clients',
  //       icon: 'happyEmoji',
  //     },
  //     {
  //       label: 'Projets',
  //       href: '#projects',
  //       icon: 'calendar',
  //     },
  //   ],
  // },
  // {
  //   label: 'resources',
  //   entries: [
  //     {
  //       label: 'Zoliens',
  //       href: '#resources',
  //       icon: 'profile2Users',
  //     },
  //   ],
  // },
  // {
  //   label: 'settings',
  //   entries: [
  //     {
  //       label: 'Paramètres',
  //       href: '#settings',
  //       icon: 'settingAlt',
  //       subNavItems: [
  //         { label: 'Dolor sit amet', href: '#DolorSit' },
  //         { label: 'Lorem ipsum', href: '#LoremIpsum' },
  //         { label: 'Amet sit', href: '#AmetSit' },
  //       ],
  //     },
  //   ],
  // },
];

function readDesktopMenuState() {
  const savedMenuPreference = localStorage.getItem('menu_state');
  return savedMenuPreference ? savedMenuPreference === 'true' : true;
}

export function PageLayout({
  title, children, user, logout, className,
}) {
  const { pathname } = useLocation();
  const isMobile = useMediaQuery(MOBILE_MEDIA_QUERY);
  const [isMenuOpen, setIsMenuOpen] = useState(() => (
    window.matchMedia(MOBILE_MEDIA_QUERY).matches ? false : readDesktopMenuState()
  ));

  useEffect(() => {
    if (isMobile) {
      setIsMenuOpen(false);
    } else {
      setIsMenuOpen(readDesktopMenuState());
    }
  }, [isMobile]);

  useEffect(() => {
    if (isMobile) setIsMenuOpen(false);
  }, [pathname, isMobile]);

  const handleToggleMenu = () => {
    setIsMenuOpen((prevState) => {
      const nextState = !prevState;
      if (!isMobile) localStorage.setItem('menu_state', nextState.toString());
      return nextState;
    });
  };

  const handleCloseMenu = () => {
    if (isMobile) setIsMenuOpen(false);
  };

  return (
    <div className={cn([styles.wrapper, isMenuOpen && styles.menuIsOpen, className])}>
      {isMobile && isMenuOpen ? (
        <button
          type="button"
          className={styles.backdrop}
          aria-label="Fermer le menu"
          onClick={handleCloseMenu}
        />
      ) : null}
      <Menu
        className={styles.menu}
        logo={<Logo />}
        menuButtonLabel="Réduire le menu"
        onMenuButtonClick={handleToggleMenu}
        isOpen={isMenuOpen}
      >
        {menuItems.map((item, index) => (
          <Fragment key={item.label}>
            {index === 0 ? null : <hr />}
            {item.entries.map(((entry) => (
              <MenuEntry
                key={entry.label}
                isFolded={!isMenuOpen}
                {...entry}
                isActive={pathname.includes(entry.href)}
              />
            )))}
          </Fragment>
        ))}
      </Menu>

      <div className={styles['content-wrapper']}>
        {title && user.name ? (
          <Header
            title={title}
            userName={user.name}
            userAvatarUrl={user.photo}
            logout={logout}
            onOpenMenu={isMobile ? handleToggleMenu : undefined}
            isMenuOpen={isMenuOpen}
          />
        ) : null}
        <main className={styles.main}>
          {children}
        </main>
      </div>
    </div>
  );
}

PageLayout.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  user: PropTypes.shape({
    name: PropTypes.string.isRequired,
    photo: PropTypes.string.isRequired,
  }).isRequired,
  className: PropTypes.string,
};

PageLayout.defaultProps = {
  title: '',
  className: '',
};

export default PageLayout;
